<template>
  <div>
    <Newsletter
      v-for="newsletterInfo in activeNewsletters"
      :data="newsletterInfo"
    />
  </div>
</template>
<script>
import dynamicLocalization from "@/mixins/dynamic-localization";
import Newsletter from "./Newsletter.vue";
import ACTIVE_NEWSLETTERS from "@/data/newsletter/active.yml";

const activeNewsletters = ACTIVE_NEWSLETTERS.map((newsletterId) => {
  return require(`@/data/newsletter/${newsletterId}`);
});

export default {
  mixins: [dynamicLocalization],
  components: { Newsletter },
  data() {
    return {
      activeNewsletters,
    };
  },
};
</script>
<i18n src="./i18n.json" />
<i18n src="@/locales/global.json" />
